import { db } from "./firebase"
import { collection, addDoc, serverTimestamp } from "firebase/firestore"

function getDevice(){

const ua = navigator.userAgent

if(/mobile/i.test(ua)) return "mobile"
if(/tablet/i.test(ua)) return "tablet"

return "desktop"

}

/* extract listing id from airbnb link */

function extractListingId(url){

if(!url) return null

const match = url.match(/rooms\/(\d+)/)

return match ? match[1] : null

}

function getUTM(){

const params = new URLSearchParams(window.location.search)

return{
utm_source:params.get("utm_source"),
utm_medium:params.get("utm_medium"),
utm_campaign:params.get("utm_campaign"),
utm_term:params.get("utm_term"),
utm_content:params.get("utm_content")
}

}

/* detect page source */

function getPageSource(page){

if(page === "revenuecalc") return "page_revenuecalc"
if(page === "contactus") return "page_contactus"
if(page === "chatbox") return "page_chatbox"

return "page_unknown"

}

export const saveLead = async(data)=>{

console.log("saveLead triggered")

const pageSource = getPageSource(data?.page)

/* airbnb link handling */

let airbnbLink = data?.airbnbLink || null
let listingId = data?.listingId || null

if(!listingId && airbnbLink){
listingId = extractListingId(airbnbLink)
}

/* traffic attribution */

const referrer = document.referrer || null
const landingPage = window.location.href

const lead = {

page: pageSource,

leadType: data?.leadType || "manual",

airbnbLink: airbnbLink,

listingId: listingId,

propertyDetails: data?.propertyDetails || null,

leadDetails: data?.leadDetails || null,

source: data?.source || "calculator",

meta:{
path:window.location.pathname,
device:getDevice(),
referrer:referrer,
landingPage:landingPage,
...getUTM()
},

createdAt:serverTimestamp()

}

console.log("Saving lead:",lead)

const ref = await addDoc(collection(db,"leads"),lead)

console.log("Lead stored:",ref.id)

return ref.id

}